// extracted by mini-css-extract-plugin
module.exports = {"root":"SortableItem_root__34up2","dragIcon":"SortableItem_dragIcon__3Pe5a","disabled":"SortableItem_disabled__1Z9ds"};